import { ValidationError, ValidationErrors } from "src/errors";
import { ReviewClaimConfirmationFormDataKey } from "src/types/forms/claims/reviewClaimConfirmationForm";
import { FormValidator } from "../formValidator";

export class ReviewClaimConfirmationFormValidator extends FormValidator {
  private static validateClaimId(value: unknown): ValidationError<"claimId"> | undefined {
    if (!value || typeof value !== "string" || value.trim().length === 0) {
      return new ValidationError("Claim ID is required", "claimId");
    }

    const trimmedClaimId = value.trim().toUpperCase();
    if (trimmedClaimId.length < 3) {
      return new ValidationError("Claim ID must be at least 3 characters", "claimId");
    }

    return undefined;
  }

  private static validateConfirmationMessage(value: unknown): ValidationError<"confirmationMessage"> | undefined {
    if (!value || typeof value !== "string" || value.trim().length === 0) {
      return new ValidationError("Confirmation message is required", "confirmationMessage");
    }

    const trimmed = value.trim();
    if (trimmed.length < 5) {
      return new ValidationError("Confirmation message must be at least 5 characters", "confirmationMessage");
    }

    if (value.length > 2000) {
      return new ValidationError("Confirmation message must be 2000 characters or less", "confirmationMessage");
    }

    return undefined;
  }

  private static readonly validationStrategies: Record<
    ReviewClaimConfirmationFormDataKey,
    (inputValue: unknown) => ValidationError<ReviewClaimConfirmationFormDataKey> | undefined
  > = {
    claimId: ReviewClaimConfirmationFormValidator.validateClaimId,
    confirmationMessage: ReviewClaimConfirmationFormValidator.validateConfirmationMessage,
    creditFiles: () => undefined // No validation for credit files
  };

  static validateClaimConfirmationFormData<T extends ReviewClaimConfirmationFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(
      formData,
      ReviewClaimConfirmationFormValidator.validationStrategies
    ) as ValidationErrors<T>;
  }
}
